import { createStackNavigator } from '@react-navigation/stack'
import React from 'react'
import { headerMode, screenOptions } from '../utils/helpers/commonUtils'
import { InvoicePreview } from './Contractor/InvoicesTab/InvoicePreview'
import ScreenSelector from './Contractor/InvoicesTab/Invoice/ScreenSelector'
import { paths } from './links'
import { InvoiceListing } from './Contractor/InvoicesTab/InvoiceListing/InvoiceListing'
import CompanyInvoicesPay from './Contractor/InvoicesTab/Invoice/CompanyInvoicesPay'
import { InvoiceDetails } from './Contractor/InvoicesTab/Invoice/InvoiceDetails'
import { CoBrandingHeader } from '../ui/white-label-components/Header'
import LinkBankAccount from './Contractor/MoreTab/Wallet/LinkPaymentScreens/LinkBankAccount'
import AddCreditDebitCard from './Contractor/AddCreditDebitCard'
import { Source } from '../store/AddPaymentMethodStore'
import { SelectProject } from './Contractor/InvoicesTab/SelectProject'

const Stack = createStackNavigator()

export default () => {
  const source = Source.INVOICE_LINK
  return (
    <>
      <CoBrandingHeader />
      <Stack.Navigator
        initialRouteName={paths.InvoiceLink.Listing}
        screenOptions={screenOptions}
        headerMode={headerMode}
      >
        <Stack.Screen
          name={paths.InvoiceLink.Listing}
          component={InvoiceListing}
        />
        <Stack.Screen
          name={paths.InvoiceLink.Details}
          component={ScreenSelector}
        />
        <Stack.Screen
          name={paths.InvoiceLink.Pay}
          component={CompanyInvoicesPay}
        />
        <Stack.Screen
          name={paths.InvoiceLink.Invoice}
          component={InvoiceDetails}
        />
        <Stack.Screen
          name={paths.InvoiceLink.AttachmentPreview}
          component={InvoicePreview}
        />
        <Stack.Screen
          name={paths.LinkCard}
          component={(props) => (
            <AddCreditDebitCard {...props} source={source} />
          )}
        />
        <Stack.Screen
          name={paths.LinkBank}
          component={(props) => <LinkBankAccount {...props} source={source} />}
        />
        <Stack.Screen
          name={paths.Console.Payables.SelectProject}
          component={SelectProject}
        />
      </Stack.Navigator>
    </>
  )
}
